import { render, staticRenderFns } from "./yigd.vue?vue&type=template&id=66d0f834&scoped=true&"
import script from "./yigd.vue?vue&type=script&lang=js&"
export * from "./yigd.vue?vue&type=script&lang=js&"
import style0 from "./yigd.vue?vue&type=style&index=0&id=66d0f834&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d0f834",
  null
  
)

export default component.exports